import { render, staticRenderFns } from "./insightsModal.vue?vue&type=template&id=fbcb98d4&"
import script from "./insightsModal.vue?vue&type=script&lang=js&"
export * from "./insightsModal.vue?vue&type=script&lang=js&"
import style0 from "./insightsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports